"use client";

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/shared/ui/dropdown-menu";
import { Ico20ArrowRight } from "@/shared/assets/icons/ico_20_arrow_right";
import { cn } from "@/shared/lib";
import { useTransition } from "react";
import { setUserLocale } from "@/shared/lib/i18n";
import type { Locale } from "@/shared/config/i18n";

interface LocaleSwitcherSelectProps {
  locale: string;
  isTransparentTheme: boolean;
  setIsHovered: (isHovered: boolean) => void;
}

const LABELS = {
  ko: "KR",
  en: "EN",
  pt: "POR",
};

export function LocaleSwitcherSelect({ isTransparentTheme, locale, setIsHovered }: LocaleSwitcherSelectProps) {
  const [isPending, startTransition] = useTransition();

  const onChangeLocale = (locale: string) => {
    startTransition(() => {
      setUserLocale(locale as Locale);
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          "body-md-medium rounded-20 group pc:mr-0 tb:h-[42px] tb:w-[74px] tb:mr-14 mr-[42px] flex h-[34px] w-16 cursor-pointer items-center justify-center gap-[6px] border border-gray-100 text-gray-900 group-hover:border-gray-100 group-hover:text-gray-900 focus:outline-none",
          isTransparentTheme ? "pc:text-white" : "text-gray-900",
          isPending && "pointer-events-none opacity-60",
        )}
      >
        {LABELS[locale as keyof typeof LABELS]}
        <Ico20ArrowRight className="size-4 rotate-90 transition-transform duration-300 group-data-[state=open]:rotate-[270deg]" />
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="!rounded-20 tb:!px-4 pc:!py-0 tb:!py-[10px] tb:!w-[74px] tb:!min-w-[74px] pc:!h-[112px] tb:!h-[102px] scrollbar-hide flex !h-[86px] !w-16 !min-w-16 flex-col items-start justify-center gap-[2px] !border !border-gray-100 bg-white px-[14px] py-0 shadow-none"
        onMouseEnter={() => setIsHovered(false)}
        onMouseLeave={() => setIsHovered(true)}
      >
        <DropdownMenuItem
          className="body-md-medium hover:!text-primary-500 w-full cursor-pointer"
          onClick={() => onChangeLocale("ko")}
        >
          KR
        </DropdownMenuItem>
        <DropdownMenuItem
          className="body-md-medium hover:!text-primary-500 w-full cursor-pointer"
          onClick={() => onChangeLocale("en")}
        >
          EN
        </DropdownMenuItem>
        <DropdownMenuItem
          className="body-md-medium hover:!text-primary-500 w-full cursor-pointer"
          onClick={() => onChangeLocale("pt")}
        >
          POR
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
